import { CommuneVhu } from 'types/BonEnlevementGardien';

/**
 * checks if a provided value can be recognized as a communeVhu
 * we do so by checking the existance of required fields
 * @param value to check
 */
export function isCommune(value: unknown): value is CommuneVhu {
  if (typeof value === 'object' && value !== null) {
    let isCommuneFound = false;
    let isCodePostalMissingOrString = true;
    Object.entries(value).forEach(entry => {
      const key: string = entry[0];
      const value: unknown = entry[1];
      if (key === 'commune' && typeof value === 'string') {
        isCommuneFound = true;
      } else if (key === 'codePostal') {
        isCodePostalMissingOrString = typeof value === 'string';
      }
    });
    return isCommuneFound && isCodePostalMissingOrString;
  }
  return false;
}
